import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type TableHeadProps = ComponentProps<'th'>;

const TableHead = ({ className, ...props }: TableHeadProps) => {
  return (
    <th
      data-slot="table-head"
      className={cn(
        'h-7 px-2 text-left align-middle font-semibold text-gray-900 [&:has([role=checkbox])]:pr-0',
        className,
      )}
      {...props}
    />
  );
};

export default TableHead;
